import { Injectable } from "@angular/core";
import { DbTableDefinition } from "src/app/_services/persistence/db-persistence/db-table-definition";

@Injectable({
  providedIn: 'root'
})
export class TagTemplateDbTableDefinition extends DbTableDefinition {
    tableName = 'tagtemplates';
    tableStructure = `(id BIGINT(20) PRIMARY KEY null,
        label TEXT NOT NULL,  
        databag LONGTEXT
      );`;

      constructor() {
        super();
        // Add UpdateStatements to Map
      }
}